import './VideoScreen.scss';
import React from 'react';
import { recordEventCustomOnly, RELIABLE } from 'utilities/uTagging';
import { COMPLETED, PROGRAMMED } from 'constants/video/status';
import { VIDEO_SELFIE, VIDEO_CALL } from 'constants/identityMethod';
import { VideoScreenDispatcher } from './VideoScreenDispatcher/VideoScreenDispatcher';
import { EXTERNAL_IBAN, PRE_CANCELLED_STATUS } from 'constants/statusProcess';
import { CREDIT_CARD } from 'constants/userProfile';
import { PollingContextProvider } from 'components/newIdentifyMethods/VideoScreen/contexts/PollingContext';

export const VideoScreen = ({
    type,
    userProfile,
    change,
    clientDefiniteKO,
    video,
    flags,
    startPolling,
    stopPolling,
}) => {
    const getVideoTagName = () => {
        const VIDEO_RELIABLES = {
            [VIDEO_CALL]: RELIABLE['videoCall'],
            [VIDEO_SELFIE]: RELIABLE['videoSelfie'],
        };

        return VIDEO_RELIABLES[type];
    };

    const leaveModalTag = option => {
        const videoTagName = getVideoTagName();
        recordEventCustomOnly(
            {
                categoriaEvento: 'eventos onboarding',
                accionEvento: `${videoTagName}/modal-atras/`,
                etiquetaEvento: `${option ? `${option} ` : ''}modal atras`,
            },
            `/onboarding/${videoTagName}/modal-atras/`
        );
    };

    const handlePrevious = () => {
        change('userProfile.identityStatus', PROGRAMMED);
        change('userProfile.videoCallClause', false);
        change('userProfile.agreeVideoCallClauseCheck', false);
        change('userProfile.videoFinishByUser', true);
    };
    const handleFinishVideoSelfie = ({ statusCode, onboardingStatus }) => {
        if (onboardingStatus === PRE_CANCELLED_STATUS) return clientDefiniteKO();
        change('userProfile.identified', statusCode === COMPLETED);
        change('userProfile.identityStatus', statusCode);
        change('userProfile.status', onboardingStatus);
        userProfile.investmentType === CREDIT_CARD && change('userProfile.status', EXTERNAL_IBAN);
    };

    return (
        <PollingContextProvider startPolling={startPolling} stopPolling={stopPolling}>
            <VideoScreenDispatcher
                flags={flags}
                identityType={type}
                videoUrl={video.get('videoUrl')}
                leaveModalTag={leaveModalTag}
                handlePrevious={handlePrevious}
                onFinishVideoSelfie={handleFinishVideoSelfie}
                userProfile={userProfile}
                onCloseButtonClick={handlePrevious}
            />
        </PollingContextProvider>
    );
};
